module.exports = __webpack_public_path__ + "static/media/3DPPA33.52a140c0.jpg";